import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filterText'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.name.toLowerCase().includes(searchText);
        });
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/filterString.pipe.ts